var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kefu_v"},[_c('div',{staticClass:"kefu_back",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../../views/images/item/back.png"),"alt":""}})]),_c('iframe',{attrs:{"src":_vm.data.kefu_link}})])
}
var staticRenderFns = []

export { render, staticRenderFns }